import { collection, doc, getDoc, getDocs, orderBy, query, setDoc, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { db } from '../Admin/Config/Config';
import { getAuth } from 'firebase/auth';

// Star Rating Component
function StarRating({ rating, setRating }) {
  return (
    <div className="flex items-center space-x-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <svg
          key={star}
          onClick={() => setRating(star)}
          className={`w-7 h-7 cursor-pointer ${star <= rating ? 'text-yellow-400' : 'text-gray-400'}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.175c.969 0 1.371 1.24.588 1.81l-3.38 2.455a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.38-2.454a1 1 0 00-1.175 0l-3.38 2.454c-.784.57-1.838-.196-1.54-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.05 9.394c-.783-.57-.38-1.81.588-1.81h4.175a1 1 0 00.95-.69l1.286-3.967z" />
        </svg>
      ))}
    </div>
  );
}

export default function BookDetails() {
  const [book, setBook] = useState(null);
  // Review states
  const [reviews, setReviews] = useState([]);
  const [newReview, setNewReview] = useState("");
  const [newRating, setNewRating] = useState(0);
  const [submitting, setSubmitting] = useState(false);
   const urlParams = new URLSearchParams(window.location.search);
   const bookId = urlParams.get("id");
  useEffect(() => {
 
    if (bookId) {
      fetchBook(bookId);
      fetchReviews();
      fetchUser(getAuth().currentUser?.uid)
    } else {
      window.location.href = "/book";
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ================ Fetch reviews ============== //
  const fetchReviews = async() =>{
    const ref = collection(db, "jaffers_english_book_reviews");
    const q = query(ref, where("book_id", "==", bookId), where("status","==", true),orderBy("date","desc"));
    var data = [];
    const querySnap = await getDocs(q);
    querySnap.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    setReviews(data);
  }
  // ================ Fetch User details ============== //
  const [userDetails, setUserDetails] = useState(null);
  const fetchUser = async (userId) => {
    const userSnap = await getDoc(doc(db, "users", userId));
    if (userSnap.exists()) {
      setUserDetails({ id: userSnap.id, ...userSnap.data() });
    } else {
      console.error("User not found");  
    }
  };
// ================ Fetch book details ============== //
  const fetchBook = async (id) => {
    const bookSnap = await getDoc(doc(db, "jaffers_english_books", id));
    if (bookSnap.exists()) {
      setBook({ id: bookSnap.id, ...bookSnap.data() });
    } else {
      window.location.href = "/book";
    }
  };

  // ============= Submit review stub ================ //
  const handleSubmitReview = async (e) => {
    e.preventDefault();
    if( newRating === 0 || newReview.trim() === "") {
      alert("Please provide a rating and review.");
      return;
    } else {
      setSubmitting(true);
      const reviewData = {
        book_id: bookId,
        name: userDetails?.name || "",
        rating: newRating,
        review: newReview,
        date: new Date(),
        status: true, 
        uid: getAuth().currentUser?.uid || "",
      };
      const reviewsRef = doc(db, "jaffers_english_book_reviews", bookId+ getAuth().currentUser?.uid);
      await setDoc(reviewsRef, reviewData, { merge: true });
      setNewReview("");
      setNewRating(0);
      setSubmitting(false);
      fetchReviews();
    }
  };

  return (
    <div className="bg-black text-white min-h-screen">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          <div className="md:col-span-1 flex justify-center items-start">
            <img
              src={book?.img_url ?? ""}
              alt="Book Cover"
              className="w-full max-w-xs md:max-w-sm h-auto object-cover rounded-lg shadow-2xl border-2 border-gray-900"
            />
          </div>

          <div className="md:col-span-2">
            <h1 className="text-2xl lg:text-2xl font-extrabold text-white leading-tight">
              {book?.title}
            </h1>
            <p className="text-xl lg:text-2xl text-emerald-400 mt-2 font-medium">
              by {book?.author}
            </p>
            
            <div className="mt-6 flex items-center gap-6 text-lg">
                <p className="text-gray-400">
                    Release Year: <span className="text-white font-semibold">{book?.release_year}</span>
                </p>
            </div>

            <p className="mt-6 text-gray-300 leading-relaxed max-w-3xl">
              {book?.book_overview}
            </p>

            {book?.type === "paperback" && (
                <div className="mt-8">
                    <a
                      href="https://wa.me/1234567890"
                      className="inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3 px-8 rounded-lg transition duration-300 ease-in-out transform hover:scale-105 shadow-lg"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-whatsapp"
                        viewBox="0 0 16 16"
                    >
                        <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                    </svg>
                    <span>Buy Now</span>
                    </a>
                </div>
            )}
          </div>
        </div>

        {book?.type === "paperback" && (
          <div className="mt-12 border-t border-gray-800 pt-10">
            <h2 className="text-xl font-bold text-white mb-8 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Verified Reviews
            </h2>

            <div className="space-y-6 mb-12">
              {reviews.length === 0 ? (
                <div className="bg-black border border-gray-800 rounded-xl p-8 text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-600 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                  <p className="text-gray-400 text-lg">No reviews yet. Be the first to share your thoughts!</p>
                </div>
              ) : (
                reviews.map((review) => (
                  <div key={review.id} className="bg-black border border-gray-800 rounded-xl p-6 shadow-md hover:border-gray-700 transition-all duration-300">
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-emerald-600 flex items-center justify-center">
                          <span className="text-white font-bold">{review.name.charAt(0).toUpperCase()}</span>
                        </div>
                        <div>
                          <span className="font-semibold text-white text-lg">
                            {review.name}
                          </span>
                          <div className="flex items-center mt-1">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <svg
                                key={star}
                                className={`w-4 h-4 ${
                                  star <= review.rating
                                    ? "text-yellow-400"
                                    : "text-gray-600"
                                }`}
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.175c.969 0 1.371 1.24.588 1.81l-3.38 2.455a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.38-2.454a1 1 0 00-1.175 0l-3.38 2.454c-.784.57-1.838-.196-1.54-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.05 9.394c-.783-.57-.38-1.81.588-1.81h4.175a1 1 0 00.95-.69l1.286-3.967z" />
                              </svg>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="text-gray-500 text-sm">
                        {new Date(review.date?.toDate()).toLocaleDateString()}
                      </div>
                    </div>
                    <p className="text-gray-300 leading-relaxed">{review.review}</p>
                  </div>
                ))
              )}
            </div>

            <div className="bg-black border border-gray-800 rounded-xl p-6 md:p-8 shadow-lg hover:border-gray-700 transition-all duration-300">
              <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                Write a Review
              </h3>
              <form onSubmit={handleSubmitReview} className="space-y-6">
                <div>
                  <label className="block text-gray-300 mb-2 font-medium text-sm uppercase tracking-wide">
                    Rating
                  </label>
                  <StarRating rating={newRating} setRating={setNewRating} />
                </div>
                <div>
                  <label className="block text-gray-300 mb-2 font-medium text-sm uppercase tracking-wide">
                    Review
                  </label>
                  <textarea
                    className="w-full p-4 rounded-lg bg-black text-gray-200 border border-gray-800 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-300"
                    rows={4}
                    value={newReview}
                    onChange={(e) => setNewReview(e.target.value)}
                    placeholder="Share your experience with this book..."
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="w-full sm:w-auto bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3 px-8 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 flex items-center justify-center gap-2"
                  disabled={submitting || newRating === 0 || newReview.trim() === ""}
                >
                  {submitting ? (
                    <>
                      <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      <span>Submitting...</span>
                    </>
                  ) : (
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                      </svg>
                      <span>Submit Review</span>
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
